/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getAllowedOutputs } from '../block_compatibility_checks';
import { getCurrentSat, getBandArray } from '../dataset';

Blockly.Blocks['output_optical_stats'] = {
    init: function () {
        const generateVisOptions = (function (self) {
            return function () {
                let sat = getCurrentSat(self);
                if ((sat !== null) && (sat !== '')) {
                    return [["All", 'all']].concat(getBandArray[sat]());
                } else {
                    return [["All", 'all']].concat(getBandArray['l8']());
                }
            }
        })(this);

        let dropdown = generateVisOptions;
        this.appendDummyInput()
            .appendField("Optical Image Statistics")
        this.appendDummyInput()
            .appendField("Band: ")
            .appendField(new Blockly.FieldDropdown(dropdown), "statsBand")

        this.setPreviousStatement(true, 'optical_stats');
        this.setNextStatement(true, getAllowedOutputs('optical_stats'));
        this.setStyle('dashboards');
        this.setTooltip("Outputs minimum, mean, median, and maximum values of optical image bands.");
        this.setHelpUrl("");

    },
};